import { SystemCatalogItemStatus } from '@/queries/system_catalog/system_catalog.schema'

export const SYSTEM_CATALOG_ITEM_STATUSES: (
  | Exclude<SystemCatalogItemStatus, 'Unknown'>
  | 'All'
)[] = ['All', 'Active', 'Inactive']

export type SystemCatalogItemStatuses =
  (typeof SYSTEM_CATALOG_ITEM_STATUSES)[number]

export const TYPE_OPTIONS = ['Service', 'Good'] as const
